import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale';
import SafeImg from '@/components/SafeImg';

const LiveCard = ({ live }) => {
  const isLive = live.status === 'live';
  // STEP 8-LIVE-STREAM-D · LiveKit 방송이면 내부 viewer 로 · 외부 방송이면 기존 stream_url 로
  const isLiveKit = live.streaming_provider === 'livekit' && live.streaming_session_id;
  const target = isLive
    ? (isLiveKit ? `/live-view/${live.streaming_session_id}` : (live.stream_url || '#'))
    : `/seller/${live.seller_id}`;
  const openNewTab = isLive && !isLiveKit;

  return (
    <Link
      to={target}
      target={openNewTab ? '_blank' : '_self'}
      className="group block bg-white dark:bg-[#141414] border border-black/5 dark:border-white/10 rounded-lg overflow-hidden hover:-translate-y-1 hover:shadow-sm transition-all duration-200"
      data-testid="live-card"
    >
      <div className="relative aspect-video overflow-hidden bg-gray-100 dark:bg-gray-800">
        <SafeImg
          src={live.thumbnail}
          kind="broadcast"
          alt={live.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {isLive && (
          <div className="absolute top-3 left-3 px-3 py-1 bg-[#FF3B30] text-white text-xs font-bold rounded-full animate-pulse" data-testid="live-badge">
            LIVE
          </div>
        )}
        {!isLive && (
          <div className="absolute top-3 left-3 px-3 py-1 bg-black/70 text-white text-xs font-medium rounded" data-testid="scheduled-time">
            {format(new Date(live.scheduled_at), 'M월 d일 HH:mm', { locale: ko })}
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-start space-x-3 mb-2">
          <SafeImg
            src={live.seller_photo}
            kind="avatar"
            alt={live.seller_name}
            className="w-10 h-10 rounded-full object-cover"
          />
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-sm tracking-tight line-clamp-2 mb-1" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid="live-title">{live.title}</h3>
            <p className="text-xs text-gray-600 dark:text-gray-400" data-testid="seller-name">{live.seller_name}</p>
          </div>
        </div>
        <div className="flex items-center space-x-4 text-xs text-gray-500 dark:text-gray-400">
          <span className="flex items-center space-x-1" data-testid="platform"><span>{live.platform}</span></span>
          <span className="flex items-center space-x-1"><Clock size={12} /><span>{live.duration}분</span></span>
        </div>
      </div>
    </Link>
  );
};

export default LiveCard;
